/**
 * ApiGest API
 * ApiGest API documentation
 *
 * OpenAPI spec version: 1.0.0
 * Contact: info@eneasys.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ContextGroupDTO } from './contextGroupDTO';

export interface ContextUserDTO { 
    id?: number;
    status: ContextUserDTO.StatusEnum;
    type: ContextUserDTO.TypeEnum;
    userCode: string;
    userMemberOfs?: Array<ContextGroupDTO>;
}
export namespace ContextUserDTO {
    export type StatusEnum = 'ACTIVE' | 'DISABLED' | 'ACCEPTANCE';
    export const StatusEnum = {
        ACTIVE: 'ACTIVE' as StatusEnum,
        DISABLED: 'DISABLED' as StatusEnum,
        ACCEPTANCE: 'ACCEPTANCE' as StatusEnum
    };
    export type TypeEnum = 'PERSON' | 'SERVICE';
    export const TypeEnum = {
        PERSON: 'PERSON' as TypeEnum,
        SERVICE: 'SERVICE' as TypeEnum
    };
}